module.exports = __webpack_public_path__ + "img/prompt-suggestion.faf8472f.svg";